var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCitrus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12942_10024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9937 76.9874C64.9019 76.9874 76.9874 64.9019 76.9874 49.9937C76.9874 35.0855 64.9019 23 49.9937 23C35.0855 23 23 35.0855 23 49.9937C23 64.9019 35.0855 76.9874 49.9937 76.9874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6849 29.2709V45.4696C50.6849 46.6886 52.1553 47.2918 53.0098 46.4373L64.3954 35.0517C64.9735 34.4736 64.9107 33.5436 64.2949 33.0158C60.9647 30.2134 56.7925 28.3786 52.2181 27.9137C51.4012 27.8383 50.6849 28.454 50.6849 29.2709Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0226 47.4049L34.6873 36.0696C34.1092 35.4915 33.1541 35.5543 32.6389 36.1953C29.9621 39.5506 28.2404 43.6977 27.876 48.2218C27.8132 49.0261 28.4289 49.7298 29.2332 49.7298H45.0675C46.2865 49.7298 46.8897 48.2595 46.0352 47.4049H46.0226Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0549 51.0996H29.3212C28.4918 51.0996 27.8634 51.8285 27.9639 52.6579C28.4918 57.0689 30.2888 61.0777 33.0033 64.3074C33.5311 64.9232 34.461 64.986 35.0391 64.408L46.01 53.4371C46.8646 52.5825 46.2614 51.1122 45.0424 51.1122L45.0549 51.0996Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3151 45.4696V29.2709C49.3151 28.454 48.5988 27.8257 47.7819 27.9137C43.2076 28.3661 39.0354 30.2008 35.7051 33.0158C35.0894 33.5436 35.0265 34.4736 35.6046 35.0517L46.9902 46.4373C47.8448 47.2918 49.3151 46.6886 49.3151 45.4696Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9774 53.4245L64.9484 64.3954C65.5264 64.9735 66.4564 64.9106 66.9842 64.2949C69.6986 61.0652 71.5083 57.0563 72.0361 52.6453C72.1366 51.8159 71.5083 51.087 70.6789 51.087H54.9451C53.7261 51.087 53.1229 52.5574 53.9774 53.4119V53.4245Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9451 49.7298H70.7794C71.5963 49.7298 72.1995 49.0261 72.1366 48.2218C71.7722 43.6851 70.0505 39.5506 67.3738 36.1953C66.8585 35.5543 65.9034 35.4789 65.3254 36.0696L53.99 47.4049C53.1355 48.2595 53.7387 49.7298 54.9577 49.7298H54.9451Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6849 55.3598V70.7291C50.6849 71.546 51.4012 72.1743 52.2181 72.0863C56.5788 71.6591 60.5625 69.9625 63.8174 67.3737C64.4583 66.8585 64.5337 65.9034 63.943 65.3253L53.0098 54.3921C52.1553 53.5376 50.6849 54.1408 50.6849 55.3598Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9903 54.3921L36.0571 65.3253C35.479 65.9034 35.5418 66.8585 36.1827 67.3737C39.4375 69.9625 43.4213 71.6591 47.782 72.0863C48.5988 72.1617 49.3151 71.546 49.3151 70.7291V55.3598C49.3151 54.1408 47.8448 53.5376 46.9903 54.3921Z",
    fill: "#7BA0C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12942_10024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitrus);
export default __webpack_public_path__ + "static/media/citrus.b3e0303bd0950079c47c9c8d8fefaaeb.svg";
export { ForwardRef as ReactComponent };